module.exports = __webpack_public_path__ + "static/media/helexia_icon_card.40c475fc.svg";